import React from "react";
import pxToRem from "~libs/pxToRem";

const MulticotizadorContent: React.FC<{ children?: React.ReactNode }> = ({
  children,
}) => {
  return (
    <section
      style={{
        width: "100%",
        maxWidth: pxToRem(500),
        display: "flex",
        flexDirection: "column",
      }}
    >
      {children}
    </section>
  );
};

export default MulticotizadorContent;
